import request from '@/utils/request';
import { loginCompany } from '@/utils/LoginContext';

export async function save(payload) {
  return request(`/iwms-basic/basic/deliveryNumLinkConfig/save`, {
    method: 'POST',
    body: payload,
  });
}

export async function modify(payload) {
  return request(`/iwms-basic/basic/deliveryNumLinkConfig/modify`, {
    method: 'POST',
    body: payload,
  });
}

export async function page(payload) {
  return request(`/iwms-basic/basic/deliveryNumLinkConfig/page`, {
    method: 'POST',
    body: payload
  })
}

export async function get(payload) {
  return request(`/iwms-basic/basic/deliveryNumLinkConfig/get?uuid=${payload.uuid}`)
}

export async function getDeliveryCompanyType() {
  return request(`/iwms-basic/basic/deliveryNumLinkConfig/getDeliveryCompanyType`)
}

export async function getAllDeliveryConfig() {
  return request(`/iwms-basic/basic/deliveryNumLinkConfig/getAllDeliveryConfig?companyUuid=${loginCompany().uuid}`)
}

export async function remove(payload) {
  return request(`/iwms-basic/basic/deliveryNumLinkConfig/remove?uuid=${payload.uuid}`)
}
